// Kalite: şikayet kanbanı, şikayet detayı, puanlar, kalite paneli (C49–C52): yönlendirmeler (izin + bayrak korumalı, tembel yüklenir).
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const ComplaintBoard = load(() => import('./ComplaintBoard'), 'ComplaintBoard');
const ComplaintDetail = load(() => import('./ComplaintDetail'), 'ComplaintDetail');
const Ratings = load(() => import('./Ratings'), 'Ratings');
const QualityDashboard = load(() => import('./QualityDashboard'), 'QualityDashboard');

export const qualityRoutes = (
  <>
    <Route path="sikayetler" element={guard(ComplaintBoard, 'quality')} />
    <Route path="sikayetler/:id" element={guard(ComplaintDetail, 'quality')} />
    <Route path="puanlar" element={guard(Ratings, 'quality')} />
    <Route path="kalite" element={guard(QualityDashboard, 'quality')} />
  </>
);
